module.exports = __webpack_public_path__ + "static/media/Screenshot_3-thumb.5d81015c.png";